export type TypeChip = 'single' | 'multiple' | 'dynamic';

export enum ChipRole {
    OPTION = 'option',
    LISTITEM = 'listitem',
    RADIO = 'radio'
}
